module.exports = __webpack_public_path__ + "img/white.63a80ac6.svg";